import React from "react";

// In Al's words when discussing a suitable loader for classwize login "ah the infamous 'Alien nipple' loader", thus the component name was born there and then
class AlienNippleLoader extends React.Component {
	render() {
		return (
			<div className="alien-nipple-loader">
				<div className="double-bounce1" />
				<div className="double-bounce2" />
			</div>
		);
	}
}

export default AlienNippleLoader;
